import { useT } from "../../shared/i18n";
import { ActionBar, Button } from "../../shared/ui";

const REASON_ID = "publish-disabled-reason-text";

export type PublishBlock = "stale" | "blocked" | null;

/**
 * Bottom bar of the Draft preview: reset and publish. A disabled publish
 * always says why (design rule: no bare grey button).
 */
export function DraftActionBar({
  block,
  onReset,
  onPublish,
}: {
  /** Why publishing is unavailable; `null` when it is available. */
  block: PublishBlock;
  onReset: () => void;
  onPublish: () => void;
}) {
  const t = useT();
  const reason =
    block === "stale"
      ? t("draft.staleBase.title")
      : block === "blocked"
        ? t("draft.incompatible.title")
        : null;
  return (
    <ActionBar className="-mx-gutter mt-auto">
      <div className="flex flex-col gap-2.5">
        {reason && (
          <p
            id={REASON_ID}
            data-testid="publish-disabled-reason"
            className="text-footnote text-fg-muted"
          >
            {reason}
          </p>
        )}
        <div className="flex gap-3 [&>*]:flex-1">
          <Button variant="secondary" onClick={onReset}>
            {t("draft.resetShort")}
          </Button>
          <Button
            disabled={block !== null}
            aria-describedby={reason ? REASON_ID : undefined}
            onClick={onPublish}
          >
            {t("draft.publish")}
          </Button>
        </div>
      </div>
    </ActionBar>
  );
}
